<template>
	<div class="image-viewer">
		<el-image-viewer v-if="props.showViewer" :initial-index="index" @close="close" :url-list="props.list" />
	</div>
</template>

<script setup lang="ts">
	import { ElImageViewer } from "element-plus";
	import { defineProps } from "vue";
	
	const emit = defineEmits(["close"])

	const props = defineProps<{
		list: Array<any>,
		showViewer: boolean,
		index: number
	}>();
	
	const close = () => {
		props.showViewer = false
		emit('close')
	}
</script>

<style>
</style>